import { configureStore } from "@reduxjs/toolkit";
import { studentsApi } from "./services/students/studentsApi";
import authSlice from "./services/authentication/authSlice";
import { authApi } from "./services/authentication/authApi";
import { academicPositionsApi } from "./services/nomenclatures/academicPositionsApi";
import { academicRanksApi } from "./services/nomenclatures/academicRanksApi";
import { bankStatusesApi } from "./services/nomenclatures/bankStatusesApi";
import { academicYearsApi } from "./services/nomenclatures/academicYearsApi";
import { admissionReasonsApi } from "./services/nomenclatures/admissionReasonsApi";
import { buildingsApi } from "./services/nomenclatures/buildingsApi";
import { citiesApi } from "./services/nomenclatures/citiesApi";
import { countriesApi } from "./services/nomenclatures/countriesApi";
import { degreesApi } from "./services/nomenclatures/degreesApi";
import { departmentsApi } from "./services/nomenclatures/departmentsApi";
import { facultiesApi } from "./services/nomenclatures/facultiesApi";
import { feeTypesApi } from "./services/nomenclatures/feeTypesApi";
import { groupsApi } from "./services/nomenclatures/groupsApi";
import { identificationTypesApi } from "./services/nomenclatures/identificationTypesApi";
import { masterDegreeTypesApi } from "./services/nomenclatures/masterDegreeTypesApi";
import { municipalitiesApi } from "./services/nomenclatures/municipalitiesApi";
import { planTypesApi } from "./services/nomenclatures/planTypesApi";
import { qualificationsApi } from "./services/nomenclatures/qualificationsApi";
import { regionsApi } from "./services/nomenclatures/regionsApi";
import { schoolProfilesApi } from "./services/nomenclatures/schoolProfilesApi";
import { schoolsApi } from "./services/nomenclatures/schoolsApi";
import { semesterTypesApi } from "./services/nomenclatures/semesterTypesApi";
import { sessionTypesApi } from "./services/nomenclatures/sessionTypesApi";
import { specialitiesApi } from "./services/nomenclatures/specialitiesApi";
import { specialityFeesApi } from "./services/nomenclatures/specialityFeesApi";
import { specialityFormsApi } from "./services/nomenclatures/specialityFormsApi";
import { specialityModesApi } from "./services/nomenclatures/specialityModesApi";
import { specialityTypesApi } from "./services/nomenclatures/specialityTypesApi";
import { studentStatusesApi } from "./services/nomenclatures/studentStatusesApi";
import { subjectControlTypesApi } from "./services/nomenclatures/subjectControlTypesApi";
import { subjectsApi } from "./services/nomenclatures/subjectsApi";
import { subjectTypesApi } from "./services/nomenclatures/subjectTypesApi";
import { teacherStatusesApi } from "./services/nomenclatures/teacherStatusesApi";
import { universitiesApi } from "./services/nomenclatures/universitiesApi";
import { universityFieldsApi } from "./services/nomenclatures/universityFieldsApi";
import { universitySpecialitiesApi } from "./services/nomenclatures/universitySpecialitiesApi";
import { foreignLanguagesApi } from "./services/nomenclatures/foreignLanguagesApi";
import { sexesApi } from "./services/nomenclatures/sexesApi";
import { dormitorySpecialCasesApi } from "./services/nomenclatures/dormitorySpecialCasesApi";
import studentsSlice from "./services/students/studentsSlice";
import layoutSlice from "./services/base/layoutSlice";
import plansSlice from "./services/plans/plansSlice";
import { plansApi } from "./services/plans/plansApi";
import { planSubjectsApi } from "./services/planSubjects/planSubjectsApi";
import { oAuthApi } from "./services/authentication/oAuthApi";
import { paymentsApi } from "./services/payments/paymentsApi";
import { studentDocumentsApi } from "./services/studentDocuments/studentDocumentsApi";
import { studentDormitoriesApi } from "./services/studentDormitories/studentDormitoriesApi";
import { dashboardApi } from "./services/dashboard/dashboardApi";
import { searchApi } from "./services/search/searchApi";
import { teachersApi } from "./services/teachers/teachersApi";
import { fnPositionsApi } from "./services/nomenclatures/fnPositionsApi";
import teachersSlice from "./services/teachers/teachersSlice";
import { protocolsApi } from "./services/protocols/protocolsApi";
import protocolsSlice from "./services/protocols/protocolsSlice";
import { examTypesApi } from "./services/nomenclatures/examTypesApi";
import { facultyTypesApi } from "./services/nomenclatures/facultyTypesApi";
import { studentGradeTypesApi } from "./services/nomenclatures/studentGradeTypesApi";
import { scheduleApi } from "./services/schedule/scheduleApi";
import { scheduleSubjectsApi } from "./services/scheduleSubjects/scheduleSubjectsApi";
import scheduleSlice from "./services/schedule/scheduleSlice";
import { activityTypesApi } from "./services/nomenclatures/activityTypesApi";
import { hallsApi } from "./services/nomenclatures/hallsApi";
import { semesterAttestationTypesApi } from "./services/nomenclatures/semesterAttestationTypesApi";
import { nacidEventsApi } from "./services/nacidEvents/nacidEventsApi";
import { userbackMiddleware } from "./services/userback/userbackMiddleware";

export const store = configureStore({
  reducer: {
    auth: authSlice,
    layout: layoutSlice,
    students: studentsSlice,
    plans: plansSlice,
    teachers: teachersSlice,
    protocols: protocolsSlice,
    schedules: scheduleSlice,
    [authApi.reducerPath]: authApi.reducer,
    [oAuthApi.reducerPath]: oAuthApi.reducer,
    [studentsApi.reducerPath]: studentsApi.reducer,
    [studentDocumentsApi.reducerPath]: studentDocumentsApi.reducer,
    [academicPositionsApi.reducerPath]: academicPositionsApi.reducer,
    [academicRanksApi.reducerPath]: academicRanksApi.reducer,
    [academicYearsApi.reducerPath]: academicYearsApi.reducer,
    [admissionReasonsApi.reducerPath]: admissionReasonsApi.reducer,
    [bankStatusesApi.reducerPath]: bankStatusesApi.reducer,
    [buildingsApi.reducerPath]: buildingsApi.reducer,
    [citiesApi.reducerPath]: citiesApi.reducer,
    [countriesApi.reducerPath]: countriesApi.reducer,
    [degreesApi.reducerPath]: degreesApi.reducer,
    [departmentsApi.reducerPath]: departmentsApi.reducer,
    [facultiesApi.reducerPath]: facultiesApi.reducer,
    [facultyTypesApi.reducerPath]: facultyTypesApi.reducer,
    [feeTypesApi.reducerPath]: feeTypesApi.reducer,
    [groupsApi.reducerPath]: groupsApi.reducer,
    [identificationTypesApi.reducerPath]: identificationTypesApi.reducer,
    [masterDegreeTypesApi.reducerPath]: masterDegreeTypesApi.reducer,
    [municipalitiesApi.reducerPath]: municipalitiesApi.reducer,
    [planTypesApi.reducerPath]: planTypesApi.reducer,
    [qualificationsApi.reducerPath]: qualificationsApi.reducer,
    [regionsApi.reducerPath]: regionsApi.reducer,
    [schoolProfilesApi.reducerPath]: schoolProfilesApi.reducer,
    [schoolsApi.reducerPath]: schoolsApi.reducer,
    [semesterTypesApi.reducerPath]: semesterTypesApi.reducer,
    [sessionTypesApi.reducerPath]: sessionTypesApi.reducer,
    [specialitiesApi.reducerPath]: specialitiesApi.reducer,
    [specialityFeesApi.reducerPath]: specialityFeesApi.reducer,
    [specialityFormsApi.reducerPath]: specialityFormsApi.reducer,
    [specialityModesApi.reducerPath]: specialityModesApi.reducer,
    [specialityTypesApi.reducerPath]: specialityTypesApi.reducer,
    [studentStatusesApi.reducerPath]: studentStatusesApi.reducer,
    [subjectControlTypesApi.reducerPath]: subjectControlTypesApi.reducer,
    [subjectsApi.reducerPath]: subjectsApi.reducer,
    [subjectTypesApi.reducerPath]: subjectTypesApi.reducer,
    [teacherStatusesApi.reducerPath]: teacherStatusesApi.reducer,
    [universitiesApi.reducerPath]: universitiesApi.reducer,
    [universityFieldsApi.reducerPath]: universityFieldsApi.reducer,
    [universitySpecialitiesApi.reducerPath]: universitySpecialitiesApi.reducer,
    [plansApi.reducerPath]: plansApi.reducer,
    [planSubjectsApi.reducerPath]: planSubjectsApi.reducer,
    [sexesApi.reducerPath]: sexesApi.reducer,
    [paymentsApi.reducerPath]: paymentsApi.reducer,
    [studentDormitoriesApi.reducerPath]: studentDormitoriesApi.reducer,
    [foreignLanguagesApi.reducerPath]: foreignLanguagesApi.reducer,
    [dormitorySpecialCasesApi.reducerPath]: dormitorySpecialCasesApi.reducer,
    [fnPositionsApi.reducerPath]: fnPositionsApi.reducer,
    [dashboardApi.reducerPath]: dashboardApi.reducer,
    [searchApi.reducerPath]: searchApi.reducer,
    [teachersApi.reducerPath]: teachersApi.reducer,
    [protocolsApi.reducerPath]: protocolsApi.reducer,
    [examTypesApi.reducerPath]: examTypesApi.reducer,
    [studentGradeTypesApi.reducerPath]: studentGradeTypesApi.reducer,
    [scheduleApi.reducerPath]: scheduleApi.reducer,
    [scheduleSubjectsApi.reducerPath]: scheduleSubjectsApi.reducer,
    [activityTypesApi.reducerPath]: activityTypesApi.reducer,
    [hallsApi.reducerPath]: hallsApi.reducer,
    [semesterAttestationTypesApi.reducerPath]: semesterAttestationTypesApi.reducer,
    [nacidEventsApi.reducerPath]: nacidEventsApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .concat(studentsApi.middleware)
      .concat(studentDocumentsApi.middleware)
      .concat(authApi.middleware)
      .concat(oAuthApi.middleware)
      .concat(academicPositionsApi.middleware)
      .concat(academicRanksApi.middleware)
      .concat(bankStatusesApi.middleware)
      .concat(academicYearsApi.middleware)
      .concat(admissionReasonsApi.middleware)
      .concat(buildingsApi.middleware)
      .concat(citiesApi.middleware)
      .concat(countriesApi.middleware)
      .concat(degreesApi.middleware)
      .concat(departmentsApi.middleware)
      .concat(facultiesApi.middleware)
      .concat(facultyTypesApi.middleware)
      .concat(feeTypesApi.middleware)
      .concat(groupsApi.middleware)
      .concat(identificationTypesApi.middleware)
      .concat(masterDegreeTypesApi.middleware)
      .concat(municipalitiesApi.middleware)
      .concat(planTypesApi.middleware)
      .concat(qualificationsApi.middleware)
      .concat(regionsApi.middleware)
      .concat(schoolProfilesApi.middleware)
      .concat(schoolsApi.middleware)
      .concat(semesterTypesApi.middleware)
      .concat(sessionTypesApi.middleware)
      .concat(specialitiesApi.middleware)
      .concat(specialityFeesApi.middleware)
      .concat(specialityFormsApi.middleware)
      .concat(specialityModesApi.middleware)
      .concat(specialityTypesApi.middleware)
      .concat(studentStatusesApi.middleware)
      .concat(subjectControlTypesApi.middleware)
      .concat(subjectsApi.middleware)
      .concat(subjectTypesApi.middleware)
      .concat(teacherStatusesApi.middleware)
      .concat(universitiesApi.middleware)
      .concat(universityFieldsApi.middleware)
      .concat(universitySpecialitiesApi.middleware)
      .concat(plansApi.middleware)
      .concat(planSubjectsApi.middleware)
      .concat(sexesApi.middleware)
      .concat(paymentsApi.middleware)
      .concat(studentDormitoriesApi.middleware)
      .concat(foreignLanguagesApi.middleware)
      .concat(dormitorySpecialCasesApi.middleware)
      .concat(fnPositionsApi.middleware)
      .concat(dashboardApi.middleware)
      .concat(searchApi.middleware)
      .concat(teachersApi.middleware)
      .concat(examTypesApi.middleware)
      .concat(scheduleApi.middleware)
      .concat(scheduleSubjectsApi.middleware)
      .concat(protocolsApi.middleware)
      .concat(studentGradeTypesApi.middleware)
      .concat(activityTypesApi.middleware)
      .concat(hallsApi.middleware)
      .concat(semesterAttestationTypesApi.middleware)
      .concat(nacidEventsApi.middleware)
      .concat(userbackMiddleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
